import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Optional,
  Output,
} from '@angular/core'
import {
  CmsSiteContextSelectorComponent,
  ContextServiceMap,
  GlobalMessageService,
  GlobalMessageType,
  SiteContext,
} from '@spartacus/core'
import { CmsComponentData, SiteContextType } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { ChangeCustAccountService } from '../change-cust-account.service'
import { ofType, Actions } from '@ngrx/effects'
import { Router } from '@angular/router'
import { OccCartAdapter } from '@spartacus/cart/base/occ'
import { MultiCartFacade } from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import { SpinnerOverlayService } from '../../../../shared/components/spinner-overlay/spinner-overlay.service'

@Component({
  standalone: false,
  selector: 'vs-change-legal-entity',
  templateUrl: './change-legal-entity.component.html',
  styleUrls: ['./change-legal-entity.component.scss'],
})
export class ChangeLegalEntityComponent implements OnInit {
  entity: string
  @Input()
  public legalEntitis
  @Input()
  public legalEntitisListss
  public entityUid
  loading = true

  @Output()
  public selectedLegalEntity = new EventEmitter()

  @Output()
  public closePage = new EventEmitter()

  @Input()
  changeFlag

  @Input()
  selectId

  @Input()
  defaultEntity

  @Input() context: SiteContextType
  siteContextService: SiteContext<any>
  public legalEntitisList$: Observable<any>
  public legalEntitisList
  public radioSelected: string
  change = false
  defaultCurrency = ''
  showList: boolean
  currencyCode: any
  constructor(
    protected componentData: CmsComponentData<CmsSiteContextSelectorComponent>,
    private changeCustAccountService: ChangeCustAccountService,
    private globalMessageService: GlobalMessageService,
    private multiCartFacade: MultiCartFacade,
    private occAdapter: OccCartAdapter,
    private actions$: Actions,
    private spinnerOverlayService: SpinnerOverlayService,
    private router: Router
  ) {
    this.showList = false
  }

  ngOnInit(): void {
    this.legalEntitisList = this.legalEntitisListss
    if (this.changeFlag) {
      this.change = true
    }
    this.legalEntitisList$ = this.changeCustAccountService.getLegalEntities(
      this.legalEntitis
    )
    this.legalEntitisList$.subscribe((res) => {
      this.legalEntitisList = res
      for (let i = 0; i < this.legalEntitisList?.vsSalesArea?.length; i++) {
        if (this.legalEntitisList?.vsSalesArea[i]?.isDefaultVsSalesArea) {
          this.defaultEntity =
            this.legalEntitisList.vsSalesArea[i].salesOrganization
          this.entityUid = this.legalEntitisList.vsSalesArea[i].uid
        }
      }
    })
  }
  goBack() {}
  onEntityChange(entity) {
    this.defaultEntity = entity.salesOrganization
    this.entityUid = entity.uid
    this.currencyCode = entity?.currency?.isocode
    this.defaultCurrency = entity?.currency?.isocode
    if (!this.defaultCurrency) {
      this.defaultCurrency = 'USD'
    }
  }
  update() {
    this.changeCustAccountService
      .updateLegalEntities(this.legalEntitis, this.entityUid)
      .subscribe(
        (res) => {
          this.closePage.emit(false)
          this.changeCustAccountService.getChangeLegalEntity(true)
          this.spinnerOverlayService.show()
          this.occAdapter
            .create('current')
            .pipe(take(1))
            .subscribe(
              (occData) => {
                this.multiCartFacade.loadCart({
                  userId: 'current',
                  cartId: occData.code,
                  extraData: {
                    active: true,
                  },
                })
                this.actions$
                  .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
                  .subscribe((success) => {
                    // this.currencyService.setActive(this.defaultCurrency);
                    this.spinnerOverlayService.hide()
                    this.router.navigate(['/homepage']).then((success) => {
                      window.location.reload()
                    })
                  })
              },
              (error) => {
                this.spinnerOverlayService.hide()
                this.globalMessageService.add(
                  error,
                  GlobalMessageType.MSG_TYPE_ERROR,
                  10000
                )
                window.scrollTo(0, 0)
              }
            )
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  changeEntity() {
    this.change = true
  }
  backTo() {
    this.selectedLegalEntity.emit(false)
  }
}
